var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgHeartFill = function SvgHeartFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.6 0 30 13.4 30 30S48.6 62 32 62 2 48.6 2 32 15.4 2 32 2z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 46l12.8-11.9c3.2-3.1 3.2-8 0-11-1.6-1.5-3.7-2.3-6-2.3s-4.4.8-6 2.3l-.8.8-.5-.5-.4-.4c-1.6-1.5-3.7-2.3-6-2.3s-4.3.9-5.9 2.3c-3.2 3.1-3.2 8 0 11L32 46z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 40.9l10.2-9.5c1.7-1.6 1.7-4 0-5.6-.9-.8-2.1-1.3-3.4-1.3s-2.5.5-3.3 1.2L32 29.1l-3.1-3-.3-.3c-.9-.8-2.1-1.3-3.5-1.3s-2.5.5-3.3 1.3c-1.7 1.6-1.7 4 0 5.6L32 40.9z",
    strokeWidth: 9
  }))));
};
export default SvgHeartFill;